import { defineWave } from '../schema';

/** BLOC A2 — la leçon du tir visé.
 *
 *  L'Éclat est introduit SEUL, sans popcorn autour, et c'est délibéré : une
 *  leçon donnée au milieu du bruit n'est pas une leçon. Le joueur a huit
 *  secondes pour découvrir, sans qu'on le lui dise, qu'en bougeant il déplace
 *  le tir — donc qu'il pilote la menace au lieu de la subir.
 *
 *  Le popcorn ne revient qu'ensuite, une fois la mécanique acquise. */
export default defineWave({
  id: 'a2-lecon',
  duration: 14,
  spawns: [
    { at: 0.5, enemy: 'eclat', lane: 3, count: 1, spacing: 0 },
    { at: 4.0, enemy: 'eclat', lane: 2, count: 1, spacing: 0 },
    { at: 7.0, enemy: 'eclat', lane: 4, count: 1, spacing: 0 },
    // La mécanique est comprise : on peut recommencer à occuper l'attention.
    { at: 9.5, enemy: 'mite', lane: 1, count: 4, spacing: 0.09 },
    { at: 10.5, enemy: 'eclat', lane: 3, count: 2, spacing: 0.9 },
    { at: 12.0, enemy: 'mite', lane: 5, count: 4, spacing: 0.09 },
  ],
});
